import { fetchWithAuth } from './apiUtils';
import { API_URL } from '../constants/api';

const CONFIG_API_URL = `${API_URL}/configurations`;

/**
 * Servicio para gestionar las configuraciones del sistema
 */
class ConfigurationService {
  /**
   * Obtiene todas las configuraciones del sistema desde el backend.
   * @returns {Promise<Object>} - La respuesta de la API.
   */
  async getAllConfigurations() {
    return fetchWithAuth(CONFIG_API_URL);
  }

  /**
   * Actualiza múltiples configuraciones.
   * @param {Object} configs - Un objeto donde las claves son los 'config_key' y los valores son los nuevos 'config_value'.
   * @returns {Promise<Object>} - La respuesta de la API.
   */
  async updateConfigurations(configs) {
    return fetchWithAuth(CONFIG_API_URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ configurations: configs }),
    });
  }

  /**
   * Envía un mensaje de prueba de WhatsApp.
   * @param {string} phoneNumber - El número de teléfono para la prueba.
   * @param {string} message - El mensaje de prueba.
   * @param {string} queueType - El tipo de cola: 'dispositivos' o 'suscripciones'.
   * @returns {Promise<Object>} - La respuesta de la API.
   */
  async testWhatsAppMessage(phoneNumber, message, queueType = 'dispositivos') {
    return fetchWithAuth(`${CONFIG_API_URL}/test-whatsapp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phoneNumber, message, queueType }),
    });
  }
}

// Exportar una instancia única del servicio (patrón Singleton)
const configurationService = new ConfigurationService();
export default configurationService; 